import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['selectAllCheckbox', 'unitCheckbox'];

  selectAllCheckboxTargetConnected(checkbox) {
    checkbox.addEventListener('change', (event) => {
      this.unitCheckboxTargets.forEach(
        (checkbox) =>
          (checkbox.querySelector('input').checked = event.target.checked)
      );
    });
  }

  unitCheckboxTargetConnected(checkboxFormElement) {
    checkboxFormElement.addEventListener('change', (event) => {
      this.toggleSelectAllCheckbox(event.target);
      this.toggleDescendantCheckboxes(event.target);
      this.toggleAncestorCheckboxes(event.target);
    });
  }

  toggleSelectAllCheckbox(toggledCheckbox) {
    if (toggledCheckbox.checked) {
      return;
    }

    this.selectAllCheckboxTarget.querySelector('input').checked = false;
  }

  toggleDescendantCheckboxes(toggledCheckbox) {
    if (toggledCheckbox.checked == true) {
      return;
    }

    const descendantSubUnitContainer =
      toggledCheckbox.closest('.mdc-form-field').nextElementSibling;

    if (descendantSubUnitContainer == null) {
      return;
    }

    descendantSubUnitContainer.querySelectorAll('input').forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  toggleAncestorCheckboxes(toggledCheckbox) {
    if (toggledCheckbox.checked == false) {
      return;
    }

    var parentSubUnitContainer = toggledCheckbox.closest('.sub-units');
    while (
      parentSubUnitContainer != null &&
      parentSubUnitContainer.id != 'all-units'
    ) {
      const parentCheckboxFormElement =
        parentSubUnitContainer.previousElementSibling;
      parentCheckboxFormElement.querySelector('input').checked = true;
      parentSubUnitContainer =
        parentSubUnitContainer.parentElement.closest('.sub-units');
    }
  }
}
